import React, { useRef } from 'react';

import styled from 'styled-components';

import CompaniesTableActions from './CompaniesTableActions';
import CompaniesTableCommunities from './CompaniesTableCommunities';
import CompaniesTableCompany from './CompaniesTableCompany';
import CompaniesTableDate from './CompaniesTableDate';
import CompaniesTablePrimaryUser from './CompaniesTablePrimaryUser';
import CompaniesTableShopsPerYear from './CompaniesTableShopsPerYear';
import CompaniesTableStatus from './CompaniesTableStatus';
import StyledTable from './StyledTable';
import { useCompaniesContext } from '../CompaniesContext';
import { COMPANIES_PAGE_SIZE, TABLE_ACTIONS } from '../constants';

const Container = styled.div`
  position: relative;
  display: flex;
  min-height: 0;
`;

const CompaniesStyledTable = styled(StyledTable)`
  &&&&&& {
    .ant-table-pagination.ant-pagination {
      padding-bottom: 12px;
    }
  }
`;

const CompaniesTable = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  const { loading, items, totalItemsCount, filters, setItems, setPage } = useCompaniesContext();

  const handleChange = (pagination: any, filters: any, sorter: any, extra: any) => {
    const { action } = extra;
    if (action === TABLE_ACTIONS.PAGINATE) {
      setPage(pagination.current);
    }
  };

  const columns = [
    {
      title: 'Company',
      render: (value: any, record: any) => <CompaniesTableCompany item={record} />,
    },
    {
      title: 'Primary User',
      render: (value: any, record: any) => <CompaniesTablePrimaryUser item={record} />,
    },
    {
      title: 'Communities & Competitors',
      render: (value: any, record: any) => <CompaniesTableCommunities item={record} />,
    },
    {
      title: 'Shop Per Year',
      render: (value: any, record: any) => <CompaniesTableShopsPerYear item={record} />,
    },
    {
      title: 'Created',
      render: (value: any, record: any) => <CompaniesTableDate item={record} />,
    },
    {
      title: 'Status',
      render: (value: any, record: any) => <CompaniesTableStatus item={record} />,
    },
    {
      title: '',
      width: 100,
      render: (value: any, record: any) => <CompaniesTableActions item={record} />,
    },
  ];

  return (
    <Container ref={containerRef}>
      <CompaniesStyledTable
        columns={columns}
        dataSource={items}
        rowKey={(record: any) => record.id}
        onChange={handleChange}
        showSorterTooltip={false}
        loading={loading}
        pagination={{
          size: 'small',
          position: ['bottomLeft'],
          showSizeChanger: false,
          current: filters.page,
          pageSize: COMPANIES_PAGE_SIZE,
          total: totalItemsCount,
          showTotal: (total, range) => {
            const displayedItems = range[1] - range[0] + 1;
            return (
              <span>
                Showing {displayedItems} of {total} records
              </span>
            );
          },
        }}
      />
    </Container>
  );
};

export default CompaniesTable;
